import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Route, Switch, useLocation, useRouteMatch } from 'react-router-dom'
import { usePermissions } from 'hooks/usePermissions'
import { FormattedMessage } from 'react-intl'
import Tabs from 'components/Tabs'
import Organizations from 'containers/Organizations'
import Users from 'containers/Users'
import Zones from 'containers/Zones'
import Groups from 'containers/Groups'
import NavigationHeader from 'components/NavigationHeader/NavigationHeader'
import {
  fetchOrganizations,
  fetchUsers,
  fetchPlatforms,
  fetchZones,
  onOrganizationsPageUnmount,
  selectIsInitialized,
  setIsInitialized,
  fetchGroups,
  fetchVerticals,
} from 'store/global'
import messages from './messages'
import styles from './OrganizationsPage.scss'

export default function OrganizationsPage() {
  const dispatch = useDispatch()
  const permissions = usePermissions()

  const isAppInitialized = useSelector(selectIsInitialized)

  useEffect(() => {
    if (!isAppInitialized) return

    return () => {
      dispatch(onOrganizationsPageUnmount())
    }
  }, [isAppInitialized])

  useEffect(() => {
    if (!permissions.isInitialized) return

    dispatch(fetchUsers())
    dispatch(fetchPlatforms())
    dispatch(fetchVerticals())
    dispatch(fetchZones())
    dispatch(fetchOrganizations())
    dispatch(fetchGroups())

    dispatch(setIsInitialized(true))
  }, [permissions])

  const { pathname } = useLocation()
  const { path } = useRouteMatch()

  const allTabs = [
    {
      key: 'organizations',
      to: `${path}/organizations`,
      isDisplayed: true,
    },
    {
      key: 'groups',
      to: `${path}/groups`,
      isDisplayed: true,
    },
    {
      key: 'zones',
      to: `${path}/zones`,
      isDisplayed: true,
    },
    {
      key: 'users',
      to: `${path}/users`,
      isDisplayed: true,
    },
  ]

  const displayedTabs = allTabs.filter(({ isDisplayed }) => isDisplayed)

  const currentTab = displayedTabs.findIndex(({ key }) => {
    const tabPath = `${path}/${key}`
    return pathname === tabPath || (key === 'organizations' && pathname === path)
  })

  const renderTabTitle = ({ key }) => (
    <span className={styles.tabTitle}>
      <FormattedMessage {...messages.tabTitles[key]} />
    </span>
  )

  return (
    <main className={styles.container}>
      <nav id='navigationHeaderWrapper' className={styles.navigationHeaderWrapper}>
        <NavigationHeader />
      </nav>
      <div className={styles.content}>
        <Tabs
          withBorders
          tabs={displayedTabs}
          renderTitle={renderTabTitle}
          currentTab={currentTab}
          tabClassName={styles.tab}
        />
        <Switch>
          <Route exact path={path} component={Organizations} />
          <Route path={`${path}/users`} component={Users} />
          <Route path={`${path}/organizations`} component={Organizations} />
          <Route path={`${path}/zones`} component={Zones} />
          <Route path={`${path}/groups`} component={Groups} />
        </Switch>
      </div>
    </main>
  )
}
